import { Injectable } from '@angular/core';

import { AppConfigurationService } from 'shared/app-configuration';

import { AccessControlApiPaths } from './access-control.paths.api';

@Injectable()
export class AccessControlConfiguration {
    apiPaths: AccessControlApiPaths;

    constructor(private readonly appConfiguration: AppConfigurationService) {
        this.apiPaths = new AccessControlApiPaths(
            this.appConfiguration.configuration.uris.accessControlService,
        );
    }
}
